import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import DotSpinner from '../../components/shared/DotSpinner';
import { apiEvents } from '../../api/apiEvents.api';
import config from '../../config';

// Две сердца — взаимная симпатия
const MutualIcon = ({ className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#A1F69E" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44923 5.00798C6.28969 5.06888 7.16544 5.47858 8.00376 6.30776C8.84186 5.47881 9.71684 5.0699 10.5565 5.01035C11.5042 4.94314 12.3419 5.32616 12.9481 5.93045C14.1398 7.11857 14.514 9.26847 13.0353 10.7473C13.0303 10.7522 13.0252 10.7571 13.0199 10.7618L8.29147 15.0449C8.12817 15.1928 7.87934 15.1928 7.71604 15.0449L2.98754 10.7618C2.98232 10.7571 2.97721 10.7522 2.97222 10.7473C1.48574 9.26077 1.85797 7.11062 3.0536 5.92342C3.66122 5.32008 4.50069 4.93926 5.44923 5.00798Z"
      fill="#010D0D"
    />
    <path
      d="M12.4854 8.50977C13.3427 8.5719 14.1987 8.94279 15.0029 9.62891C15.8072 8.9426 16.6641 8.57252 17.5215 8.51172C18.6323 8.43304 19.6067 8.88435 20.3008 9.57617C21.643 10.9144 22.1044 13.3832 20.3887 15.0996L20.3896 15.1006L20.3555 15.1328L15.627 19.415V19.416C15.2733 19.736 14.7346 19.7359 14.3809 19.416V19.415L9.65234 15.1328C9.64078 15.1223 9.62975 15.1112 9.61914 15.1006C7.89607 13.3775 8.35275 10.9073 9.70117 9.56836C10.3973 8.87717 11.3746 8.42924 12.4854 8.50977Z"
      fill="#010D0D"
      stroke="#A1F69E"
    />
  </svg>
);

// Полный список участников мероприятия — строками как в чатах
function EventParticipants() {
  const { id } = useParams();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  // Клик по участнику: есть чат → профиль чата; человек лайкнул → экран симпатии;
  // никаких отношений → анкета с кнопками лайк / супер-лайк / чат через подарок
  const handleOpenParticipant = (user) => {
    const userId = user.userId || user._id;
    if (user.chatId) {
      navigate(config.ROUTES.CHATS.PROFILE(userId));
    } else if (user.likeNotificationId) {
      navigate(config.ROUTES.MATCHS.SUPER_LIKE_PROFILE_ID(userId, user.likeNotificationId));
    } else {
      navigate(config.ROUTES.MATCHS.SUPER_LIKE_PROFILE_ID(userId, 'none'));
    }
  };

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    apiEvents
      .fetchJoins(axiosPrivate, id)
      .then((data) => {
        if (!cancelled) setUsers(data?.items || []);
      })
      .catch(() => {
        if (!cancelled) setUsers([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [axiosPrivate, id]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-y-auto">
      {users.length === 0 ? (
        <p className="text-center text-white/60 text-sm font-raleway py-10">
          Пока никто не отметился. Будьте первым!
        </p>
      ) : (
        <div className="flex flex-col">
          {users.map((user) => (
            <button
              key={user._id}
              type="button"
              onClick={() => handleOpenParticipant(user)}
              className="flex items-center gap-3 px-4 py-3 border-b border-[#233636] w-full text-left active:bg-[#043939] transition-colors cursor-pointer"
            >
              <img
                src={user.photoUrl || '/mock/stream_chat_user_avatar.png'}
                alt={user.name}
                className="w-[48px] h-[48px] rounded-full object-cover shrink-0"
              />
              <p className="text-white text-[16px] font-semibold font-raleway truncate flex-1">
                {user.name}
              </p>
              {user.isMutual && <MutualIcon className="shrink-0" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default EventParticipants;
